
import { createClient } from '@supabase/supabase-js';

// --- SUPABASE CLIENT INITIALIZATION ---
// Realtime özellikleri (Chat, Bildirimler) için kullanılır.
// Safely get environment variables and ensure they're valid strings
const supabaseUrlRaw = import.meta.env.VITE_SUPABASE_URL;
const supabaseKeyRaw = import.meta.env.VITE_SUPABASE_ANON_KEY;

export let supabase: any = null;

// Helper function to validate URL - more strict checking
const isValidUrl = (url: any): boolean => {
    // Reject undefined, null, empty string, or non-string values
    if (!url || typeof url !== 'string') return false;
    const trimmed = url.trim();
    if (trimmed === '' || trimmed === 'undefined' || trimmed === 'null') return false;
    
    // Try to parse as URL
    try {
        const parsed = new URL(trimmed);
        // Must be http or https protocol
        return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
        return false;
    }
};

// Only initialize if we have valid credentials
if (isValidUrl(supabaseUrlRaw) && supabaseKeyRaw && typeof supabaseKeyRaw === 'string' && supabaseKeyRaw.trim() !== '' && supabaseKeyRaw.trim() !== 'undefined') {
    try {
        supabase = createClient(supabaseUrlRaw.trim(), supabaseKeyRaw.trim());
        console.log('✅ Supabase client initialized successfully');
    } catch (error: any) {
        console.error('❌ Supabase initialization failed:', error?.message || error);
        // Continue without Supabase - app will work but realtime features will be disabled
        supabase = null;
    }
} else {
    // Silently skip if credentials are not available - this is expected when Supabase is paused
    if (process.env.NODE_ENV === 'development') {
        console.warn('⚠️ Supabase credentials (VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY) missing or invalid. Realtime features will be disabled.');
    }
    supabase = null;
}

/**
 * Bu modül, dosyaları Backend üzerinden Cloudflare R2'ye yükler.
 * Frontend doğrudan R2 SDK'sını kullanmaz, dosya Backend'e iletilir ve URL döner.
 */

// Dosya boyutunu kontrol et ve yükle
export const uploadFile = async (file: File, bucket?: string): Promise<string | null> => {
  if (!file) return null;

  // Dosya boyutu kontrolü (Maks 5MB)
  if (file.size > 5 * 1024 * 1024) {
    console.error("Dosya çok büyük (Maks 5MB)");
    alert("Dosya boyutu 5MB'dan büyük olamaz.");
    return null;
  }

  try {
    const formData = new FormData();
    formData.append('file', file);
    if (bucket) {
        formData.append('bucket', bucket);
    }

    const response = await fetch('/api/upload', {
        method: 'POST',
        body: formData,
        // Content-Type header'ı ekleme, browser otomatik olarak boundary ile multipart/form-data yapar.
    });

    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        const errorMessage = errorData.error || errorData.details || 'Yükleme başarısız oldu.';
        throw new Error(errorMessage);
    }

    const data = await response.json();
    if (!data.url) {
        throw new Error('Sunucudan URL alınamadı.');
    }
    
    return data.url;

  } catch (err: any) {
    console.error("Yükleme işlemi başarısız:", err);
    // Hata mesajını throw et ki yukarıda yakalanabilsin
    const errorMessage = err.message || 'Dosya yükleme başarısız oldu.';
    throw new Error(errorMessage);
  }
};
